import type { OptionType } from "../../index.types";
import { X } from "lucide-react";
import React from "react";
import { ClearIndicatorProps, components } from "react-select";

/**
 * Default clear indicator component for the Autocomplete.
 *
 * This component renders a clear button for clearing the selected options in the autocomplete dropdown.
 *
 * @returns A React element representing a clear button
 */
export const AutocompleteClearIndicator = (props: ClearIndicatorProps<OptionType, true>): React.ReactElement => {
  return (
    <components.ClearIndicator {...props}>
      <X size={16} />
    </components.ClearIndicator>
  );
};
